import { render, staticRenderFns } from "./ToggleRadioInput.vue?vue&type=template&id=612c9769&"
import script from "./ToggleRadioInput.vue?vue&type=script&lang=js&"
export * from "./ToggleRadioInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports